import { cn } from "@/lib/utils";

interface ExperienceFilterProps {
  experiences: { slug: string; label: string }[];
  selected: string;
  onChange: (slug: string) => void;
}

/**
 * Minimal pill-style filter row for experience categories on landing.
 * "Alla" is always the first option.
 */
export default function ExperienceFilter({ experiences, selected, onChange }: ExperienceFilterProps) {
  if (experiences.length === 0) return null;

  const options = [{ slug: "all", label: "Alla" }, ...experiences];

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => (
        <button
          key={opt.slug}
          onClick={() => onChange(opt.slug)}
          className={cn(
            "px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
            selected === opt.slug
              ? "bg-foreground text-background"
              : "bg-muted text-muted-foreground hover:bg-muted/80"
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
